module.exports = __webpack_public_path__ + "static/media/parrilla-2.86418af6.jpg";